import HttpClient from '../HttpClient';

class RecipeService extends HttpClient {

    ressourceUrl = '/recipe';

    constructor() {
        super();
    }

    async getPagedData(page) {
        return (await this.getPaged(this.ressourceUrl, page)).data;
    }

    async getData(id) {
        return (await this.get(`${this.ressourceUrl}/${id}`)).data;
    }
}

export default new RecipeService();
